const DATA = {
  contact: {
    email:       'danylo@zahorulko.com',
    github:      'danil09234',
    githubUrl:   'https://github.com/danil09234',
    telegram:    '@danil09234',
    telegramUrl: 'https://t.me/danil09234',
    linkedin:    'danylo-zahorulko',
    linkedinUrl: 'https://www.linkedin.com/in/danylo-zahorulko/',
  },
};

export default DATA;
